import { render, staticRenderFns } from "./FieldSetGridLayout.vue?vue&type=template&id=48ef9756&scoped=true"
import script from "./FieldSetGridLayout.vue?vue&type=script&lang=js"
export * from "./FieldSetGridLayout.vue?vue&type=script&lang=js"
import style0 from "./FieldSetGridLayout.vue?vue&type=style&index=0&id=48ef9756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ef9756",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
